<template>
<div class="chapter">
<div class="inner_page">
<h1 class="p_heading_" id="auto_bookmark_toc_1"><span class="calibre1">Salvaging Claus Day</span></h1>
<p class="p_normal"> </p>
<p class="p_norm-noindent">By J. Alan Veerkamp</p>
<p class="p_normal"> </p>
<p class="p_normal">For three years, Filo has reveled in silence and solitude as the sole occupant of a space station, where he maintains the communication satellite.</p>
<p class="p_normal">Everything changes with the appearance of Luz Espina’s lifepod. Filo shares many interests with the flirtatious Luz, though Filo’s isolation has strained his communication skills. Still, Luz pushes all his buttons… and reminds him of the last man he was attracted to—an attraction that ended in disaster because the man was straight. When Luz learns Filo has never celebrated a holiday, he vows to cobble together a Claus Day celebration for them to share. But is it merely a friendly gesture… or something more?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?bc149d42